import React, { Component } from "react";
import { Link } from "react-router-dom";
import { setProduct } from "../../store/actions";
import { connect } from "react-redux";
import QuickAddToCart from "../Menu/QuickAddToCart";
import { ReactComponent as Clock } from "../Menu/assets/alarm-clock.svg";
import {
  checkForStockWarningMessage,
  getOriginalProduct,
  getPrepTime,
  isOutOfStock,
} from "../Menu/Helpers";
import OutOfStock from "../Menu/OutOfStock";
import NotAvailable from "../Menu/NotAvailable";
import { getDiscountedPercentage, getNewPrice } from "../../Helpers/promotions";
import dairyFreeIcon from "../ActionButton/assests/no-milk.png";
import glutenFreeIcon from "../ActionButton/assests/gluten-free.png";
import sugarFreeIcon from "../ActionButton/assests/sugar-free.png";
import nutFreeIcon from "../ActionButton/assests/peanut-free.png";
import organicIcon from "../ActionButton/assests/bio_480.png";
import vegetarianIcon from "../ActionButton/assests/leaf.png";
import veganIcon from "../ActionButton/assests/vegan.png";
import glutenIcon from "../ActionButton/assests/gluten.png";
import nutsSesameIcon from "../ActionButton/assests/nuts_sesame.png";
import dairyIcon from "../ActionButton/assests/dairy.png";
import eggIcon from "../ActionButton/assests/egg.png";
import seafoodShellfishIcon from "../ActionButton/assests/seafood_shellfish.png";
import chilliIcon from "../ActionButton/assests/chilli.png";
import moment from "moment";
import ProductTag from "../ProductDetails/ProductTag";
import { getCurrencyIcon } from "../../Helpers/currencyConverter";

class Product extends Component {
  render() {
    const {
      settings,
      language,
      cart,
      category_id,
      store,
      product,
      usedComponents,
    } = this.props;
    const real_price = getNewPrice(
      product,
      this.props.coupon,
      this.props.discounts,
      this.props.store.smart_promos
    );

    const has_striked_price =
      product.striked_price && product.striked_price > product.price;

    const originalProduct = getOriginalProduct(
      product,
      category_id,
      store.categories
    );
    const outOfStock = isOutOfStock(originalProduct, cart, usedComponents);

    const isDiscounted =
      this.props.product.price > real_price || has_striked_price;
    const tag = this.props.tags?.find((t) => t.id == this.props.product.tag);
    const currencyIcon = getCurrencyIcon(settings)
    return (
      <div
        className="col-6 mb-5"
        style={{
          width: "50%",
          minHeight: 240,
          paddingRight: 8,
          paddingLeft: 8,
        }}
      >
        <Link
          to={{
            pathname:
              (this.props.branch.branch &&
                this.props.settings.is_branch_based_ordering) ||
              !this.props.settings.is_branch_based_ordering ||
              this.props.settings.branch_count === 1 ||
              this.props.product.hide_buy_button ||
              true
                ? `/product/${this.props.product.category}/${this.props.product.slug}`
                : "/select/branch",
            state: {
              pickupOnly: this.props.product.pickup_only,
              deliveryOnly: this.props.product.delivery_only,
            },
          }}
          onClick={() => {
            let store_product = this.props.product;

            if (
              (this.props.branch.branch &&
                this.props.settings.is_branch_based_ordering) ||
              !this.props.settings.is_branch_based_ordering ||
              this.props.settings.branch_count === 1 ||
              this.props.product.hide_buy_button ||
              true
            ) {
              if (this.props.category_id !== this.props.product.category_id) {
                try {
                  store_product = this.props.store.categories.find(
                    (category) => category.id === this.props.product.category_id
                  );
                  if (this.props.product.parent) {
                    store_product = store_product.products
                      .find((parent) => parent.id === this.props.product.parent)
                      .children.find(
                        (product) => product.id === this.props.product.id
                      );
                  } else {
                    store_product = store_product.products.find(
                      (product) => product.id === this.props.product.id
                    );
                  }
                } catch (err) {
                  store_product = this.props.product;
                }
              }

              this.props.setProduct(store_product || this.props.product);
            } else {
              if (this.props.settings.is_branch_based_ordering)
                this.props.setNextPage(
                  `/product/${this.props.product.category}/${this.props.product.slug}`
                );
            }
          }}
          style={{ color: "black" }}
        >
          <div
            style={{
              background: `url(${
                this.props.product.photo_medium
                  ? this.props.product.photo_medium
                  : this.props.product.photo
              }) no-repeat center center`,
              borderRadius: 7,
              backgroundSize: this.props.product.stretch_photo
                ? settings?.fit_images_to_div
                  ? "100% 100%"
                  : "cover"
                : "contain",
              width: "100%",
              display: "block",
              cursor: "pointer",
              minHeight: 240,
              position: "relative",
            }}
          >
            {this.props.product.tag && tag && (
              <ProductTag
                product={this.props.product}
                placement={tag?.placement}
                discount={Boolean(isDiscounted)}
                nextToDiscount={true}
                productInCategoryDetails={
                  this.props.productInCategoryDetails ? true : false
                }
              />
            )}
            {Boolean(isDiscounted) && (
              <div
                className="discount-sign"
                style={{
                  left: language !== "arabic" && 10,
                  right: language === "arabic" && 10,
                  backgroundColor:
                    this.props.discountTagColor || this.props.themeColor,
                  direction: language === "arabic" && "ltr",
                }}
              >
                {`${getDiscountedPercentage(
                  real_price,
                  (has_striked_price && product.striked_price) || product.price
                )} %`}
              </div>
            )}
            {this.props.product.preparation_time > 0 &&
              this.props.product.type_of_product !== "service" &&
              this.props.product.show_prep_time &&
              settings.show_prep_times && (
                <div
                  style={{
                    color: this.props.themeColor,
                    background: "rgba(255, 255, 255, 0.85)",
                    borderRadius: "0px 0px 5px 5px",
                    fontWeight: "bold",
                    width: "100%",
                    paddingTop: 5,
                    height: 30,
                    bottom: 0,
                    position: "absolute",
                  }}
                >
                  <Clock
                    className="mx-2"
                    style={{
                      width: "15px",
                      height: "15px",
                      fill: this.props.store.settings.dark,
                    }}
                  />
                  {getPrepTime(this.props.product.preparation_time, language)}{" "}
                </div>
              )}
            {this.props.product.duration > 0 &&
              this.props.product.type_of_product === "service" &&
              this.props.product.show_prep_time &&
              settings.show_prep_times && (
                <div
                  style={{
                    color: this.props.themeColor,
                    background: "rgba(255, 255, 255, 0.85)",
                    borderRadius: "0px 0px 5px 5px",
                    fontWeight: "bold",
                    width: "100%",
                    paddingTop: 5,
                    height: 30,
                    bottom: 0,
                    position: "absolute",
                  }}
                >
                  <Clock
                    className="mx-3"
                    style={{
                      width: "15px",
                      height: "15px",
                      fill: this.props.store.settings.dark,
                    }}
                  />
                  {!this.props.product.has_variants
                    ? getPrepTime(this.props.product.duration, language)
                    : language == "english"
                    ? "On selection"
                    : "حسب الاختيار"}{" "}
                </div>
              )}
          </div>
          <div>
            <p
              style={{
                fontSize: 14,
                fontWeight: "bold",
                height: 40,
                textDecoration:
                  this.props.product.not_available && "line-through",
              }}
              className={"mt-2 mb-0 cut-text-two-lines ".concat(
                language == "english" ? "text-left pl-1" : "text-right pr-1"
              )}
            >
              {checkForStockWarningMessage(
                this.props.product.show_warning_item_availability,
                this.props.product.inventory_on_hand,
                this.props.product.warning_item_availability_count,
                outOfStock,
                this.props.product.warning_item_availability_message_value,
                language,
                this.props.product.has_variants,
                this.props.product.type_of_product
              )}
              {language == "english"
                ? this.props.product.name
                : this.props.product.ar_name}
            </p>
            {settings.show_nutrition_facts && (
              <div
                className={
                  language == "english" ? "text-left pl-1" : "text-right pr-1"
                }
                style={{ height: 20 }}
              >
                {product.dietary_restrictions?.includes("Dairy free") && (
                  <img
                    src={dairyFreeIcon}
                    style={{ marginRight: 5, height: 17, width: 17 }}
                  />
                )}
                {product.dietary_restrictions?.includes("Gluten free") && (
                  <img
                    src={glutenFreeIcon}
                    style={{ marginRight: 5, height: 17, width: 17 }}
                  />
                )}
                {product.dietary_restrictions?.includes("Sugar free") && (
                  <img
                    src={sugarFreeIcon}
                    style={{ marginRight: 5, height: 17, width: 17 }}
                  />
                )}
                {product.dietary_restrictions?.includes("Nut free") && (
                  <img
                    src={nutFreeIcon}
                    style={{ marginRight: 5, height: 17, width: 17 }}
                  />
                )}
                {product.dietary_restrictions?.includes("Vegan") && (
                  <img
                    src={veganIcon}
                    style={{ marginRight: 5, height: 17, width: 17 }}
                  />
                )}
                {product.dietary_restrictions?.includes("Vegetarian") && (
                  <img
                    src={vegetarianIcon}
                    style={{ marginRight: 5, height: 17, width: 17 }}
                  />
                )}
                {product.dietary_restrictions?.includes("Organic") && (
                  <img
                    src={organicIcon}
                    style={{ marginRight: 5, height: 17, width: 17 }}
                  />
                )}
                {product.dietary_restrictions
                  ?.split(",")
                  .map((r) => r.trim())
                  .includes("Gluten") && (
                  <img
                    src={glutenIcon}
                    style={{ marginRight: 4, height: 18, width: 18 }}
                  />
                )}

                {product.dietary_restrictions?.includes("Nuts/Sesame") && (
                  <img
                    src={nutsSesameIcon}
                    style={{ marginRight: 4, height: 21, width: 21 }}
                  />
                )}

                {product.dietary_restrictions?.includes("Dairy") && (
                  <img
                    src={dairyIcon}
                    style={{ marginRight: 4, height: 21, width: 21 }}
                  />
                )}

                {product.dietary_restrictions?.includes("Egg") && (
                  <img
                    src={eggIcon}
                    style={{ marginRight: 4, height: 21, width: 21 }}
                  />
                )}

                {product.dietary_restrictions?.includes(
                  "Seafood/Shellfish"
                ) && (
                  <img
                    src={seafoodShellfishIcon}
                    style={{ marginRight: 4, height: 21, width: 21 }}
                  />
                )}

                {product.dietary_restrictions?.includes("Chilli") && (
                  <img
                    src={chilliIcon}
                    style={{ marginRight: 4, height: 21, width: 21 }}
                  />
                )}
              </div>
            )}
            {!settings.hide_short_descriptions && (
              <p
                className={"cut-text-two-lines-grid-view ".concat(
                  language == "english" ? "text-left pl-1" : "text-right pr-1"
                )}
                style={{
                  fontSize: 14,
                  color: "#333333",
                  marginTop: 3,
                  marginBottom: 3,
                  height: 38,
                  textDecoration:
                    this.props.product.not_available && "line-through",
                }}
              >
                {language == "english"
                  ? this.props.product.short_description
                  : this.props.product.ar_short_description}
              </p>
            )}
            <p
              className={"mb-4 ".concat(
                language == "arabic" ? "text-left pl-1" : "text-right pr-1 "
              )}
              style={{ fontSize: 14, color: this.props.themeColor }}
              dir={language == "english" ? "ltr" : "rtl"}
            >
              {!this.props.product.hide_buy_button ||
              this.props.product.price > 0 ? (
                <>
                  {this.props.settings.show_prices ? (
                    this.props.product.price ? (
                      this.props.product.price === real_price &&
                      !has_striked_price ? (
                        <div
                          className={
                            currencyIcon
                          }
                          style={{ fontWeight: "bold" }}
                        >
                          {`${this.props.product.price.toFixed(
                            settings.currency_decimals
                          )} ${
                            language == "english"
                              ? settings.currency_english
                              : settings.currency_local
                          }`}
                        </div>
                      ) : (
                        <div>
                          <span
                            className={`mx-2 ${
                              currencyIcon
                            }`}
                            style={{ textDecoration: "line-through" }}
                          >
                            {`${
                              has_striked_price
                                ? this.props.product.striked_price.toFixed(
                                    settings.currency_decimals
                                  )
                                : this.props.product.price.toFixed(
                                    settings.currency_decimals
                                  )
                            } ${
                              language == "english"
                                ? settings.currency_english
                                : settings.currency_local
                            }`}
                          </span>
                          <span
                            className={
                              currencyIcon
                            }
                            style={{ fontWeight: "bold" }}
                          >
                            {`${real_price.toFixed(
                              settings.currency_decimals
                            )} ${
                              language == "english"
                                ? settings.currency_english
                                : settings.currency_local
                            }`}
                          </span>
                        </div>
                      )
                    ) : language == "english" ? (
                      <p
                        className="text-right m-0"
                        style={{ fontWeight: "bold" }}
                      >
                        Price on selection
                      </p>
                    ) : (
                      <p
                        className="text-left m-0"
                        style={{ fontWeight: "bold" }}
                      >
                        السعر عند الاختيار
                      </p>
                    )
                  ) : (
                    ""
                  )}
                </>
              ) : null}
              {settings.enable_quick_add_to_cart &&
                !this.props.product.hide_buy_button &&
                this.props.product.show_quick_add_to_cart &&
                !outOfStock &&
                !this.props.product.not_available &&
                !this.props.settings.is_menu && (
                  <div
                    className={`mt-2  ${
                      (language === "arabic" && "float-left") || "float-right"
                    }`}
                    style={{ width: "100%" }}
                  >
                    <QuickAddToCart type={"grid"} product={originalProduct} />
                  </div>
                )}
              {outOfStock && (
                <div
                  className={`mt-2  ${
                    (language === "arabic" && "float-left") || "float-right"
                  }`}
                >
                  <OutOfStock
                    type_of_product={this.props.product.type_of_product}
                  />
                </div>
              )}
              {this.props.product.not_available && !outOfStock && (
                <div
                  className={`mt-2 w-100  ${
                    (language === "arabic" && "float-left") || "float-right"
                  }`}
                >
                  <NotAvailable />
                </div>
              )}
            </p>
          </div>
        </Link>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    settings: state.store.store.settings,
    themeColor: state.store.store.settings.dark,
    discountTagColor: state.store.store.settings.discount_tag_color,
    branch: state.branch,
    coupon: state.cart.promos,
    discounts: state.cart.discounts,
    store: state.store.store,
    cart: state.cart.cart,
    auth: state.auth,
    tags: state.store.store.tags,
    usedComponents: state.store.used_components,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setProduct: (product) => dispatch(setProduct(product)),
    setNextPage: (nextPage) =>
      dispatch({ type: "SET_NEXT_PAGE", payload: nextPage }),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Product);
